module.exports = __webpack_public_path__ + "static/assets/490929216162b99b6b6b68d42ad1038e.png";